<p class="text-center my-4">
  You have unsaved changes. Are you sure you want to leave this page?
</p>
<div>
  <app-dialog-footer
    (cancelAction)="close()"
    (submitAction)="confirm()"
    [submitActionName]="'Confirm'"
    [valid]="true" />
</div>